//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { questionFormType } from "../questionBankUtils";
import * as questionCatalogService from "@/modules/newCommunity/pages/operationTools/api/questionCatalogService";
import questionnaireMixin from "@/modules/newCommunity/pages/operationTools/pages/questionnaire/questionnaireMixin";
export default {
  mixins: [questionnaireMixin],
  data() {
    return {
      questionFormType,
      isBusinessTypeDisable: false,
      visible: false,
      title: "",
      isEditModel: false,
      isAddModel: false,
      loading: false,
      formRules: {
        name: [{
          required: true,
          message: "请填写分类名称"
        }]
      },
      formData: {
        name: "",
        businessType: questionFormType.QUESTIONNAIRE
      }
    };
  },
  created() {
    this.formData.communityType = this.communityType;
  },
  methods: {
    onOk() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          questionCatalogService.insertOrUpdate(this.formData).then(res => {
            if (res.code == 200) {
              this.onClose();
              if (this.isAddModel) {
                this.$message.success("新建分类成功");
              } else {
                this.$message.success("更新分类成功");
              }
              this.$emit("onOk");
            }
          }).finally(() => {
            this.loading = false;
          });
        }
      });
    },
    onShow(params = {
      formData: {}
    }) {
      this.isBusinessTypeDisable = Boolean(params.isBusinessTypeDisable);
      this.formData = {
        ...this.formData,
        ...params.formData
      };
      if (params.model == "edit") {
        this.isEditModel = true;
        this.title = "编辑分类";
      } else {
        this.isAddModel = true;
        this.title = "新增分类";
      }
      this.visible = true;
    },
    onClose() {
      this.$emit("close");
    }
  }
};